/**
 * Documentation Table of Contents
 * Automatically generates a TOC from H2 elements in the article content
 * Only active on large screens (1200px+)
 */
(function() {
  'use strict';

  function initTOC() {
    const tocContainer = document.querySelector('.docs-toc__list');
    const articleContent = document.querySelector('.docs-article__content');

    if (!tocContainer || !articleContent) return;

    const headings = articleContent.querySelectorAll('h2');

    if (headings.length === 0) {
      // Hide TOC if no headings found
      const tocWrapper = document.querySelector('.docs-toc');
      if (tocWrapper) tocWrapper.style.display = 'none';
      return;
    }

    // Build TOC items
    headings.forEach(function(heading, index) {
      // Ensure heading has an ID for linking
      if (!heading.id) {
        heading.id = 'section-' + (index + 1);
      }

      const li = document.createElement('li');
      li.className = 'docs-toc__item';

      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.className = 'docs-toc__link';
      link.textContent = heading.textContent;

      link.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.getElementById(heading.id);
        if (target) {
          const headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 20;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          // Update URL without jumping
          history.pushState(null, null, '#' + heading.id);
        }
      });

      li.appendChild(link);
      tocContainer.appendChild(li);
    });

    // Highlight active section on scroll
    let ticking = false;

    function updateActiveSection() {
      const headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
      const scrollPosition = window.scrollY + headerOffset + 50;

      let activeHeading = null;

      headings.forEach(function(heading) {
        if (heading.offsetTop <= scrollPosition) {
          activeHeading = heading;
        }
      });

      // Remove all active classes
      tocContainer.querySelectorAll('.docs-toc__link').forEach(function(link) {
        link.classList.remove('docs-toc__link--active');
      });

      // Add active class to current section
      if (activeHeading) {
        const activeLink = tocContainer.querySelector('a[href="#' + activeHeading.id + '"]');
        if (activeLink) {
          activeLink.classList.add('docs-toc__link--active');
        }
      }

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateActiveSection);
        ticking = true;
      }
    });

    // Initial check
    updateActiveSection();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTOC);
  } else {
    initTOC();
  }
})();
